import { render, staticRenderFns } from "./page-agv-article.vue?vue&type=template&id=9522e7a4&scoped=true&lang=pug&"
import script from "./page-agv-article.vue?vue&type=script&lang=js&"
export * from "./page-agv-article.vue?vue&type=script&lang=js&"
import style0 from "./page-agv-article.vue?vue&type=style&index=0&id=9522e7a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9522e7a4",
  null
  
)

export default component.exports